import { getQuery, insertQuery } from "./UdasWrapper";

export const startMcpOAuth = async (input) => {
  const data = JSON.stringify({
    query: `
      mutation StartMcpOAuth(
        $tenantId: String!
        $userId: String!
        $serverUrl: String!
        $frontendOrigin: String!
        $existingConnectionId: String
      ) {
        startMcpOAuth(
          tenant_id: $tenantId
          user_id: $userId
          server_url: $serverUrl
          frontend_origin: $frontendOrigin
          existing_connection_id: $existingConnectionId
        ) {
          isSuccessful
          message
          resultObject
        }
      }
    `,
    variables: input
  });
  const response = (await insertQuery(data)).startMcpOAuth;

  if (!response.isSuccessful) throw new Error(response.message);

  return response.resultObject;
};

export const getMcpOAuthStatus = async (tenantId, connectionId) => {
  const data = JSON.stringify({
    query: `
      query GetMcpOAuthStatus($tenantId: String!, $connectionId: String!) {
        getMcpOAuthStatus(tenant_id: $tenantId, connection_id: $connectionId) {
          isSuccessful
          message
          resultObject
        }
      }
    `,
    variables: { tenantId, connectionId }
  });
  const response = (await getQuery(data)).getMcpOAuthStatus;

  if (!response.isSuccessful) throw new Error(response.message);

  return response.resultObject;
};
